const data = [{
    id: 1,
    icon: "⭕️",
    status: "Things To Do",
    title: "Human Interest Form",
    content: "Learn a new language"
}, {
    id: 2,
    icon: "⭕️",
    status: "Things To Do",
    title: "Purchase present",
    content: "Buy a present for Mother's Day"
}, {
    id: 3,
    icon: "⭕️",
    status: "Things To Do",
    title: "Invest in investments",
    content: "Collect this month's salary"
}, {
    id: 4,
    icon: "⭕️",
    status: "Things To Do",
    title: "Daily reading",
    content: "Finish reading Intro to Machine Learning"
}];

const statuses = [{
    status: "Things To Do",
    icon: "⭕️",
    color: "#e93b81"
}, {
    status: "in progress",
    icon: "✨",
    color: "#f5abc9"
}, {
    status: "in review",
    icon: "📑",
    color: "#ffe5e2"
}, {
    status: "Finished",
    icon: "👏",
    color: "#b6c9f0"
}];


export { data, statuses };